import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-cmd',
  templateUrl: './cree-cmd.component.html',
  styleUrls: ['./cree-cmd.component.scss']
})
export class CreeCmdComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('CreeCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Créé');
    }

}
